<template>
  <div>
    某日斑筛人数详情：
    <el-date-picker v-model="date" 
    type="daterange"
    align="right"
    unlink-panels
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :picker-options="pickerOptions">
    </el-date-picker>
    <el-select v-model="hospital" placeholder="请选择医院" filterable>
      <el-option
        v-for="item in hospitalList"
        :key="item.hospitalId"
        :label="item.hospitalName"
        :value="item.hospitalId">
      </el-option>
    </el-select>
    <el-button type="success" @click="exportExcel">导出表格</el-button>
    <br />
    <br />
    <br />
    某时间段斑筛日统计：
    <el-date-picker
      v-model="duration"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptions">
    </el-date-picker>
    <el-select v-model="hospitalDaily" placeholder="请选择医院" filterable>
      <el-option
        v-for="item in hospitalList"
        :key="item.hospitalId"
        :label="item.hospitalName"
        :value="item.hospitalId">
      </el-option>
    </el-select>
    <el-button type="success" @click="exportDailyDataExcel">导出表格</el-button>
  </div>
</template>

<script>
  import Global from '../Global'

  export default {
    name: 'HospitalDataExport',
    mounted() {
      this.getHospitalList()
    },
    data: function () {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        hospitalList: [],
        hospital: '',
        date: '',
        duration: '',
        hospitalDaily: ''
      }
    },
    methods: {
      getHospitalList() {
        let that = this
        this.axios({
          method: 'GET',
          url: Global.yunyingUrl + '/service-hospital/hospital/getAllHospital'
        }).then(resp => {
          let data = resp.data
          if (data.code === 1000) {
            that.hospitalList = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      exportExcel() {
        if (this.date === '' || this.hospital === '') {
          this.$message({
            type: 'error',
            message: '请选择时间和医院'
          })
        }
        let durationStart = this.date[0].setHours(0, 0, 0, 0)
        let durationEnd = this.date[1].setHours(0, 0, 0, 0)
        this.axios({
          method: 'GET',
          url: Global.yunyingUrl + '/service-order/order/findOrderByDateAndHospitalId?durationStart=' + durationStart + '&durationEnd=' +
            durationEnd + '&hospitalId=' + this.hospital,
          responseType: 'blob'
        }).then(response => {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          let url = URL.createObjectURL(blob)
          window.open(url)
          this.$message({
            type: 'success',
            message: '正在下载'
          })
        })
      },
      exportDailyDataExcel() {
        if (this.duration === '' || this.hospitalDaily === '') {
          this.$message({
            type: 'error',
            message: '请选择时间和医院'
          })
        }
        let durationStart = this.duration[0].setHours(0, 0, 0, 0)
        let durationEnd = this.duration[1].setHours(0, 0, 0, 0)
        this.axios({
          method: 'GET',
          url: Global.yunyingUrl + "/service-order/data/getDailyData?durationStart=" 
          + durationStart + "&durationEnd=" + durationEnd + "&hospitalId=" + this.hospitalDaily,
          responseType: 'blob'
        }).then(response => {
          let blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          let url = URL.createObjectURL(blob)
          window.open(url)
          this.$message({
            type: 'success',
            message: '正在下载'
          })
        })
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/hospital_data_export/HospitalDataExport.vue